import { IconEnergy, IconFactory, IconFlame, IconFlask, IconLayers, IconWater, IconWind } from "@/lib/icons";

const icons = { layers: IconLayers, factory: IconFactory, flask: IconFlask, flame: IconFlame, wind: IconWind, water: IconWater, energy: IconEnergy };

export function NavigationIcon({ name, size = 17 }: { name: string; size?: number }) {
  const Icon = icons[name as keyof typeof icons] ?? IconLayers;
  return <Icon size={size} />;
}
